import { render } from "./TextOnlyFieldComponent.vue?vue&type=template&id=1e1c08a3&ts=true"
import script from "./TextOnlyFieldComponent?vue&type=script&lang=ts"
export * from "./TextOnlyFieldComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/xebel/xebel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__